<template>
  <div class="relative" :class="configDashboard ? 'bg-white' : ''">
    <div
      v-if="configDashboard"
      class="flex items-center justify-between absolute z-10 p-6 w-full"
    >
      <h4>Wallet</h4>
      <vs-chip
        transparent
        color="#FBA727"
        class="text-base text-center cursor-pointer"
        @click.native="removeUserWalletCard"
      >
        Remove
      </vs-chip>
    </div>
    <main
      class="p-3 md:p-6 wallet__container"
      :class="configDashboard ? 'opacity' : ''"
    >
      <div
        class="h-full flex flex-col justify-between items-start pt-1 wallet__container__sec1"
      >
        <h3 class="mb-4">{{ $t('orgDashboard.userDashboard.walletCard') }}</h3>
        <h5 class="mb-3" id="xp">{{ xp }} XP</h5>
        <!-- <div>
          <p class="mb-0">Synced</p>
          <h6>40 XP</h6>
        </div> -->
      </div>

      <div
        class="h-full flex flex-col justify-between items-end wallet__container__sec2"
      >
        <!-- <button class="px-4 py-2">Manage</button> -->

        <!-- <div>
          <p class="mb-0">Pending</p>
          <h6>60 XP</h6>
        </div> -->
      </div>
    </main>
  </div>
</template>

<script>
export default {
  name: "UserWalletCard",
  data() {
    return {
      xp: 0,
    };
  },
  computed: {
    userTokens() {
      return this.$store.state.users.userTokens;
    },
    userWidgets() {
      return this.$store.state.dashboard.userWidgets;
    },
    configDashboard() {
      return this.$store.state.dashboard.configDashboard;
    },
    isAnimationTrue() {
      return this.$store.state.animation.isAnimationTrue;
    },
  },
  watch: {
    userTokens: {
      deep: true,
      immediate: true,
      handler(newVal) {
        if (newVal) {
          this.getUserXP(newVal);
        }
      },
    },
  },
  mounted() {
    this.getUserXP(this.userTokens);
    setTimeout(() => {
      const fp = document.getElementById("xp").getBoundingClientRect();
      this.$store.commit("animation/SET_FINAL_POSITION_FOR_XP", {
        top: fp.top,
        bottom: fp.bottom,
        left: fp.left,
        right: fp.right,
      });
    }, 750);
  },
  methods: {
    removeUserWalletCard() {
      const userWallet = this.userWidgets.find(
        (item) => item.widgetId === "USER_WALLET"
      );
      this.$store
        .dispatch("dashboard/removeWidget", userWallet)
        .then(() => {
          for (var i = 0; i < this.userWidgets.length; i++) {
            if (this.userWidgets[i].widgetId === "USER_WALLET") {
              this.$store.commit("dashboard/REMOVE_WIDGET", i);
            }
          }
          this.$store.commit("dashboard/SHOW_QUEUE_CARD", false);
        })
        .catch((err) => {
          throw err;
        });
    },
    getUserXP(tokens) {
      if (tokens && this.xp === 0) {
        let xp = tokens.find((token) => token.label === "XP");
        if (xp.tokens) {
          xp.tokens.forEach((obj) => {
            this.xp += obj.tokenValueSum;
          });
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.wallet__container {
  display: grid;
  grid-auto-flow: column;
  background-image: url("../../../assets/images/user-dashboard/wallet-widget-background-2.png"),
    url("../../../assets/images/user-dashboard/wallet-widget-background-1.png");
  background-position: left top, bottom right;
  background-repeat: no-repeat, no-repeat;
  background-size: contain, contain;
  top: 2rem;
  box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1),
    0 10px 10px -5px rgba(0, 0, 0, 0.04);
  border-radius: 0.5rem;
  background-color: white;

  &__sec1 {
    h3 {
      font-size: 1.5rem;
      font-weight: 600;
    }

    h5 {
      font-size: 1.25rem;
      font-weight: 600;
    }

    div {
      p {
        font-size: 1.125rem;
        font-weight: 400;
        color: #667085;
      }

      h6 {
        font-size: 1rem;
        font-weight: 600;
      }
    }
  }

  &__sec2 {
    button {
      color: #101828;
      background-color: #ffffff;
      border: none;
      border-radius: 99999px;
      font-size: 1.125rem;
      font-weight: 500;
    }

    div {
      p {
        font-size: 1.125rem;
        color: white;
        font-weight: 400;
      }
      h6 {
        font-size: 1rem;
        font-weight: 600;
        color: white;
      }
    }
  }
}

.opacity {
  opacity: 0.075;
}
</style>
